import { useContext } from "react";
import FormatMoney from "go-core/components/Formatters/FormatMoney";
import { OrderContext } from "../../../contexts/OrderContext";

interface Props {
	chargeName: string;
	price: number;
}

export const TipSummaryItem = ({ chargeName, price }: Props) => {
	const { currency } = useContext(OrderContext);

	return (
		<div className="order-tips-summary-item" data-testid="order-tip-charge-item">
			<span>{chargeName}</span>
			<span>{FormatMoney({ amount: price, currency })}</span>
		</div>
	);
};
